import { defineComponent as o, createBlock as a, openBlock as r, unref as l, mergeProps as p, withCtx as c, createElementVNode as m } from "vue";
import { RevIcon as i } from "@ds/components/Icon";
const v = /* @__PURE__ */ o({
  name: "IconAttachment",
  __name: "IconAttachment",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const n = t;
    return (d, e) => (r(), a(l(i), p(n, { "view-box": "0 0 24 24" }), {
      default: c(() => [...e[0] || (e[0] = [
        m("path", {
          "fill-rule": "evenodd",
          d: "M10.75 3.75a2.5 2.5 0 0 0-2.5 2.5V16.5a3.75 3.75 0 1 0 7.5 0v-9a.75.75 0 0 1 1.5 0v9a5.25 5.25 0 1 1-10.5 0V6.242a4 4 0 0 1 8 .008V16.5a2.75 2.75 0 1 1-5.5 0v-9a.75.75 0 0 1 1.5 0v9a1.25 1.25 0 1 0 2.5 0V6.25a2.5 2.5 0 0 0-2.5-2.5",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  v as default
};
